import { useEffect, useRef, useState } from "react";
import { serverFetch } from "../../server";
import { Button, Input, message, Table } from "antd";
import { discalVidName, hasSubstring, renderCheckbox } from "../../extensions/helper";
import PaymentVid from "./payment-vid";
import { fmtDateTimeFull } from "../../extensions/utils";
import { tableRenderCheckbox } from "@/extensions/table-render";

const PaymentVids = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [editId, setEditId] = useState();
  const [filter, setFilter] = useState({ serchText: ""});
  const divRef = useRef(null);

  const getData = () => {
    setLoading(true);
    serverFetch("paymentvid")
      .then(data => {
        setItems(data);
        setLoading(false);
      })
      .catch(e => {
        setLoading(false);
        message.error(e.userMessage);
      })
  }

  useEffect(getData, []);

  const columns = [
    { title: "#", dataIndex: "id", width: 100 },
    { title: "Акт.", dataIndex: "active", width: 60, render: tableRenderCheckbox},
    { title: "Наименование", dataIndex: "name", width: 400 },
    { title: "Терминал", dataIndex: "terminalVid"},
    { title: "Вид", dataIndex: "fiscal", render: discalVidName },
    { title: "Синхронизация", dataIndex: "lastSync", render: fmtDateTimeFull },
  ]

  const onClose = (refresh) => {
    setEditId();
    refresh && getData();
  }

  const divItem = editId != null && <PaymentVid id={editId} onClose={onClose} />
  const headerSize =  divRef.current?.querySelector('.ant-table-thead')?.offsetHeight ?? 0;
  const tableHeight = divRef.current ? (document.documentElement.offsetHeight - headerSize - divRef.current.getBoundingClientRect().top - window.scrollY) : 0;
  const tableWidth = (document.documentElement.offsetWidth - divRef.current?.getBoundingClientRect().left) || 0;

  const onChangeFilter = value => setFilter({ ...filter, ...value });

  const filtered = items.filter(item => {
    if (!hasSubstring(filter.serchText, item.name)) return false;
    return true;
  })

  return<div>
    <div className="sport-form-title">
      <Input placeholder="Поиск" value={filter.serchText} onChange={e => onChangeFilter({serchText: e.target.value})} />
      <Button onClick={getData}>Обновить</Button>
      <Button onClick={() => setEditId(0)}>Новый</Button>
    </div>
    <div ref={divRef} style={{width: tableWidth}}>
      <Table
        dataSource={filtered}
        columns={columns}
        rowKey="id"
        loading={loading}
        size="small"
        pagination={false}
        scroll={{ y: tableHeight }}
        rowSelection={{ type: 'radio', selectedRowKeys: [editId], renderCell: checked => <div className={checked ? "list-indicator" : ""} /> }}
        onRow={(record) => ({onClick: () => {setEditId(record.id)}})}
      /> 
    </div>
    {divItem}
  </div>
}

export default PaymentVids;